import React, {useEffect, useState, useRef} from 'react';
import { useHistory } from "react-router-dom";
import { set, get, remove } from '../../services/storage.service';
//import { saveFieldNote, loadFieldNote, checkFieldNote, removeFieldNote } from '../../services/local.fieldnote';
import axios from 'axios';
import {
    IonPage,
    IonContent, 
    IonText,
    IonButton,IonToolbar,IonIcon, IonItem,
    IonTextarea,IonAlert,IonInput,IonLoading,IonLabel,
    IonRow,IonCol, IonGrid,
    IonHeader,
    isPlatform,
    getPlatforms
} from '@ionic/react';
import { Capacitor } from '@capacitor/core';
import { logOutOutline, chevronBackOutline, arrowForwardOutline, arrowBackOutline } from 'ionicons/icons';
import FooterCom from '../../components/FooterComponent';
import LoginCheck from "../../components/LoginCheck";
import './CreateMindset.css';


const CreateFieldNote: React.FC = () => {
    
    var error = false;
    //declare all the variables 
    const [saveprojtitle,setFieldTitle] = useState<string>('');
    const [savemindsethelps,setMindHelps] = useState<string>('');
    const [savemostimportant,setMostImportant] = useState<string>('');

   
    const [showLoading, setShowLoading] = useState(false);
    const [isSaved, setIsSaved] = useState<any>('none');

    const [issuccess, setIssuccess] = useState<boolean>(false);
    const [winmessage, setWinMessage] = useState<string>("");
    const [winmessagetitle, setWinMessageTitle] = useState<string>("");
    const [color,setColor] = useState<any>("#42DD52");
    //const sendata;
    const plat = isPlatform('mobileweb');
    const desk = isPlatform('desktop');
    
    const platforms = getPlatforms();
    console.log("g",platforms);
    let myurl = "";
    if(plat || desk){
        myurl = "assets/video/analyze.mp4";
    }else{
        myurl = "public/assets/video/analyze.mp4";
    }
    console.log("myurl",myurl);
    

    setTimeout(() => {
      setShowLoading(false);
    }, 2000);

    const history = useHistory();
    function logOut(){
        console.log("logout");
        remove('cred');
        history.push('/home');
    }




    //function to submit to wordpress //,formID:any
    function PosttoServer(bodyFormData:any){
        var baseURL = 'https://explorermindsetapp.com/wp-json/'
        //validate first 
        if(bodyFormData === ""){
            error = true;
        }else{
            error = false;
        }
        if(error){  
            setWinMessage('error');
        }else{
            //then send if it's good
            get("cred").then(function (finalResult) {
                const userD = JSON.parse(finalResult);
                const token = userD.authtoken;
                const email = userD.email;
                bodyFormData.set('post_title', email);
                bodyFormData.set('logged-email',email);
                console.log(bodyFormData);
                console.log("email grabbed");
                console.log(userD)
                //axios.post(baseURL + 'contact-form-7/v1/contact-forms/2638/feedback', 
                axios.post(baseURL + 'contact-form-7/v1/contact-forms/10068/feedback', 
                    bodyFormData,
                {
                headers: { 
                    'Authentication':' Bearer ' + token 
                },
                timeout:8000,
                }).then(function (serverResponse) {
                    setShowLoading(false);
                    const postsD = serverResponse.data;
                    console.log(postsD);
                    console.log("error should popup");
                    //setLoad(true);//submission was a success
                    if(serverResponse.data.message === 'Thank you for your message. It has been sent.'){
                        const message = "Your Field Notes were saved. It may take some time to appear in the app.";
                        setWinMessage(message);
                    }else{
                        setWinMessage(serverResponse.data.message);
                    }
                    
                    if(serverResponse.data.status === 'mail_sent'){
                        const title = "Your Field Notes were saved to the server";
                        setWinMessageTitle(title);
                    }else{
                        const title = serverResponse.data.status
                        setWinMessageTitle(title);
                    }
                    console.log(serverResponse.data.status);
                    resetForm();
                })
                .catch(function (error) {
                    setShowLoading(false);
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request)
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                    console.log(error);

                    const title = "Congratulations your Field Notes were saved, it will be saved to the website and app, it may take some time to appear in the app.";
                    setWinMessage(title);

                    resetForm();
                });
            }).catch(err => {//unable to load the local storage
                console.log("e: " + err.message);
            });
        }
    }
    function resetForm(){
        //declare all the variables 
        setFieldTitle("");
        setMindHelps("");
        setMostImportant("");
        setIssuccess(true);
        console.log("popup");
    }
    function publishMM(
        saveprojtitle:any,
        savemindsethelps:any,
        savemostimportant:any,
    ){
        setShowLoading(true);
        let bodyFormData = new FormData();

        const stampTime:any = Date.now();
        
        bodyFormData.set('your-project-title',saveprojtitle);
        bodyFormData.set('your-mindet-helps',savemindsethelps);
        bodyFormData.set('your-most-important-thing',savemostimportant);
        bodyFormData.set('timestamp',stampTime);

        PosttoServer(bodyFormData);
    }
    const checkForm = () => {
        //slide level
        console.log("validate form fields");
        //check the attitudes

        if(!saveprojtitle){
            setWinMessage("A required field was missed");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }else{
            setIssuccess(false);
        }
        if(!savemindsethelps){
            setWinMessage("A required field was missed");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }else{
            setIssuccess(false);
        }
        if(!savemostimportant){
            setWinMessage("A required field was missed");
            setWinMessageTitle("Error");
            setIssuccess(true);
            return;
        }else{
            setIssuccess(false);
        }

        if(!issuccess){
            console.log("success");
            publishMM(
                saveprojtitle,
                savemostimportant,
                savemindsethelps,
            );
        }

    }

    function handleSaveFieldNotes(){
        setShowLoading(true);
    }
     //video 
     const platform = Capacitor.getPlatform();
     //const history = useHistory();
     var api: any = useRef<boolean>(false);
     let url: string = "";
     const [type,setType] = useState("");
    
     useEffect( () => {
       async function launchFullscreen(): Promise<void>  {
         //set type and set api etc
         //await set('url', url);
         await set('api', api.current ? "true" : "false");
         history.push('/createfieldnote');//try pushing this first in the history. 
         history.push('/fullscreen');
       }
         if(type.length >  0) launchFullscreen();
     },[ api, platform, history, type]);
   
     function launchPlayer(senturl:string){
         url = senturl;
         set('url', url).then(()=>{
           console.log(senturl);
           let someNum = Math.random();
           setType(someNum.toString());
           console.log(type);
         });
         
     }
     function checkIsSent(){
        setIssuccess(false);
        
     }
 
     //end video 
    return(
        <>
        <IonPage id="visual">
        <LoginCheck/>
        <IonHeader translucent={true} >
            <IonToolbar>
                <IonButton size="small" slot="start" color="primary" onClick={() => history.replace("/analyze/")} class="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
                <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  class="logout"><IonIcon slot="start" icon={logOutOutline}/>Log Out</IonButton>
            </IonToolbar>
        </IonHeader>
        <IonContent id="createpage">
        <IonGrid>
                    <IonRow>
                        <IonCol>
                        <IonLoading
                            cssClass='my-custom-class'
                            isOpen={showLoading}
                            onDidDismiss={() => setShowLoading(false)}
                            message={'Please wait...'}
                            spinner={'bubbles'}
                            duration={9000}
                        />
                             <IonAlert
                                isOpen={issuccess}
                                onDidDismiss={() => checkIsSent()}
                                cssClass="my-success-class"
                                header={winmessagetitle}
                                message={winmessage}
                                buttons={["Close"]}
                            />
                        </IonCol>
                    </IonRow>
                    <IonRow>
                    <IonText class="innertext">
                    <IonText className="plantext innertext">
      <span>[</span>  <h3>Analyze</h3> <span>]</span></IonText>
                    </IonText>
                    </IonRow>
                    <IonItem className="stripes"></IonItem>
                    <IonRow style={{padding:'10px 20px'}}>
                    <IonButton fill="outline" style={{color:'#7a5b3f',margin:'0 auto'}} onClick={(e)=>launchPlayer(myurl)}>Launch Field Notes Video</IonButton>
           
                    <IonText className="fieldnotehead">
                        Looking back and reflecting helps us take charge of our learning, builds connections and helps us become aware of skills we developed.
                    </IonText>
                        <IonText className="formlabel">
                            <IonLabel position="floating" className="formlabel">Title of Exploration</IonLabel>
                            <IonInput
                            name="exploration-title"
                            class="notes-textfield"
                            value={saveprojtitle}
                            onIonChange={(e) => setFieldTitle(e.detail.value!)}
                            ></IonInput></IonText>
                            </IonRow>
                            <IonRow style={{padding:'10px 20px'}}>
                            <IonText className="formlabel">
                            <IonLabel  position="stacked">Having an Explorer Mindset helps because</IonLabel>
                                <IonTextarea
                                name="helpsbecause"
                                class="textarea"
                                value={savemindsethelps}
                                onIonChange={(e) => setMindHelps(e.detail.value!)}
                                
                                ></IonTextarea></IonText>
                            </IonRow>
                            <IonRow style={{padding:'10px 20px'}}>
                            <IonText className="formlabel" >
                            <IonLabel position="stacked">The most important thing to me that I learned in this exploration was</IonLabel>   
                            <IonTextarea
                            name="most-important" 
                            class="textarea" 
                            value={savemostimportant}
                            maxlength={170}
                            onIonChange={(e) => setMostImportant(e.detail.value!)}
                            ></IonTextarea>
                            </IonText>
                            </IonRow>
                    </IonGrid>
            
        </IonContent>
        <IonToolbar class="slidenav">
        <IonButton onClick={()=>checkForm()}
                    color="primary" 
                    fill="solid" 
                    class="save">Save</IonButton>

        </IonToolbar>
        <FooterCom/>
        </IonPage>
        </>
    );
}
export default CreateFieldNote;